<template>
  <span class="BaseButtonContents">
    <transition name="fade">
      <BaseLoader
        v-if="loading"
        :color="loaderColor"
        size="small"
        float
      />
    </transition>

    <span
      v-if="leadingIcon"
      key="BBC-leading-icon"
      :class="[
        '_icon _icon-leading',
        ('icon-' + leadingIcon),
      ]">
    </span>

    <span
      v-if="$slots.default"
      key="BBC-text-slot"
      class="_text">
      <slot></slot>
    </span>

    <i
      v-if="trailingIcon"
      key="BBC-trailing-icon"
      :class="[
        '_icon _icon-trailing',
        ('icon-' + trailingIcon),
      ]">
    </i>
  </span>
</template>

<script>
import BaseLoader from '@/components/BaseLoader.vue';

export default {
  name: 'BaseButtonContents',

  components: {
    BaseLoader,
  },

  props: {
    loading:      { type: Boolean, default: false },
    leadingIcon:  { type: String,  default: null },
    trailingIcon: { type: String,  default: null },
    loaderColor:  { type: String,  default: 'dark' },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_variables';

._icon {
  font-size: 18px;
}
.round.medium ._icon {
  font-size: 20px;
}

._icon-leading + ._text,
._text + ._icon-trailing {
  padding-left: 4px;
}
</style>
